<template>
  <div class="component-wrapper d-flex flex-column" id="questions">
    <div class="flex-grow-1 d-flex">
      <div class="questions-sidebar primary d-flex flex-column py-1">
        <v-btn
          class="align-self-end mb-5"
          small
          text
          @click="$router.go(-1)"
          color="white"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          {{ $t('back') }}
        </v-btn>

        <div class="subtitle-1 font-weight-medium white--text text-center mb-3">
          {{ $t('messages') }}
        </div>
      </div>

      <div class="questions d-flex flex-column">
        <div
          class="questions-scroll pt-2 pb-4"
          ref="questionsScroll"
        >
          <div
            class="d-flex flex-column px-4"
            v-for="(question, index) in questions"
            :key="index"
          >
            <div class="d-flex align-center">
              <div class="body-1 mr-2 submitted-message" v-html="linkifiedMessage(question.question)"></div>

              <v-progress-circular
                class="ml-auto mr-4"
                size="12"
                width="2"
                indeterminate
                color="primary"
                v-if="loader.open && loader.id == question.id"
              ></v-progress-circular>
            </div>

            <v-divider
              class="my-2"
              v-if="index != questions.length - 1"
            ></v-divider>
          </div>
        </div>

        <v-textarea
          outlined
          hide-details
          class="mt-auto flex-grow-0 chat-textarea"
          color="primary"
          append-icon="mdi-send"
          v-model="question"
          @click:append="onSendQuestion"
          @keyup.enter.exact.prevent="onSendQuestion"
          autocomplete="off"
          :loading="loader"
          auto-grow
          rows="1"
        ></v-textarea>
      </div>
    </div>

    <Buttons />
  </div>
</template>

<script>
import Buttons from "@/views/program/Buttons";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Buttons,
  },
  data() {
    return {
      loader: {
        open: false,
        id: null,
      },
    };
  },
  computed: {
    ...mapState({
      questions: (state) => state.guide.questions,
    }),
    answered() {
      return this.questions.filter((q) => q.answered).length;
    }
  },
  mounted() {
    if (this.questions.length) {
      this.$vuetify.goTo(this.$refs.questionsScroll.clientHeight, {
        container: ".questions-scroll",
      });
    }
  },
  methods: {
    ...mapActions(["answerQuestion", "sendQuestion"]),
    linkifiedMessage(question) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return question.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    },
    async onAnswerQuestion(id, answered) {
      if (this.loader.open) return;

      this.loader = {
        open: true,
        id,
      };

      try {
        await this.answerQuestion({
          id,
          answered: !answered,
        });

        this.loader = {
          open: false,
          id: null,
        };
      } catch (e) {
        console.log(e);

        this.loader = {
          open: false,
          id: null,
        };
      }
    },
    async onSendQuestion() {
      if (!this.question) return;

      this.loader = true;

      try {
        await this.sendQuestion(this.question);

        this.loader = false;
        this.$vuetify.goTo(this.$refs.questionsWrapper.clientHeight, {
          container: ".questions-wrapper",
        });
      } catch (e) {
        console.log(e);
        this.loader = false;
      }

      this.question = "";
    },
  },
};
</script>

<style lang="scss" scoped>
  .questions-sidebar {
    width: 150px;
    flex-shrink: 0;
  }

  .questions {
    flex: 1 0 auto;
    max-width: calc(100% - 150px);
  }

  .questions-scroll {
    flex: 1 0 auto;
    overflow-y: auto;
    height: 0px;
  }

  .submitted-message {
    word-break: break-all;
  }
</style>

<style>
  #questions .chat-textarea textarea {
    max-height: 120px; /* ~5 lines (adjust based on your font/line-height) */
    overflow-y: auto;
    scrollbar-width: thin;
    margin-top: 0;
  }

  #questions .chat-textarea .v-text-field__slot {
    padding: 8px;
  }

  #questions .chat-textarea .v-input__append-inner {
    padding-left: 18px;
    margin-top: 0;
    align-self: center;
  }
</style>